var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg1",
    d: "M28.333 9.91666H7.93301C6.23301 9.91666 5.66634 9.06666 5.66634 8.49999L28.333 6.37499V4.24999C28.333 3.39999 27.483 2.69166 26.633 2.83333L5.24134 6.65833C3.82467 6.94166 2.83301 8.07499 2.83301 9.49166V28.3333C2.83301 29.8917 4.10801 31.1667 5.66634 31.1667H28.333C29.8913 31.1667 31.1663 29.8917 31.1663 28.3333V12.75C31.1663 11.1917 29.8913 9.91666 28.333 9.91666ZM26.208 22.6667C25.0747 22.6667 24.083 21.675 24.083 20.5417C24.083 19.4083 25.0747 18.4167 26.208 18.4167C27.3413 18.4167 28.333 19.4083 28.333 20.5417C28.333 21.675 27.3413 22.6667 26.208 22.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.9f99ec4b6415073d4f4822568280fec4.svg";
export { ForwardRef as ReactComponent };